export enum TachographMake {
  VDO = 'vdo',
  STONERIDGE = 'stoneridge',
}
